import * as HTMLElementCreator from '../../../libs/HTML/HTMLElementCreator';
import { INPUT_STYLE, LABEL_STYLE } from '../EditorOverlayStyles';

export interface EditorInputField {
  panel: HTMLElement;
  label: HTMLElement;
  input: HTMLInputElement;
}

export interface EditorInputConfig {
  parentElement: HTMLElement;
  labelText: string;
  onValueChanged: (value: string) => void;
  initialValue?: string;
  restrictRegEx?: RegExp;
  panelStyle?: Partial<CSSStyleDeclaration>;
  inputStyle?: Partial<CSSStyleDeclaration>;
  labelStyle?: Partial<CSSStyleDeclaration>;
}

export function createEditorInput({
  parentElement,
  labelText,
  onValueChanged,
  initialValue = '',
  restrictRegEx,
  inputStyle = {},
  labelStyle = {},
  panelStyle = {},
}: EditorInputConfig): EditorInputField {
  const panel = HTMLElementCreator.createDiv({
    parentElement,
    style: { ...panelStyle },
  });

  // Create label for input.
  const label = HTMLElementCreator.createLabel({
    parentElement: panel,
    style: { ...LABEL_STYLE, marginTop: '2px', ...labelStyle },
    labelText,
  });

  // Create input field.
  const input = HTMLElementCreator.createInputText({
    parentElement: panel,
    initialValue,
    restrictRegEx,
    editColor: '#ff0000',
    style: { ...INPUT_STYLE, width: '120px', marginTop: '2px', ...inputStyle },
    onEnterKey: () => {
      onValueChanged(input.value);
    },
  });

  return { panel, label, input };
}
